module.exports = __webpack_public_path__ + "img/202312251124442922ir.50b159a9.jpg";